<template>
  <div class="box-wrapper">
    <div class="box">
      <div class="box-header">
        <span class="title">전체구성현황</span>
      </div>
      <!-- 전체구성현황 내용 -->
      <div class="box-content">
        <el-carousel :interval="10000" trigger="click" height="80px" @change="onChangeCarousel" arrow="never" :indicator-position="objDefineList.length > 1 ? 'outside' : 'none'" :autoplay="active">
          <el-carousel-item v-for="item in objDefineList" :key="item.id">
            <!-- 왼쪽 타이틀 -->
            <div class="title-container" :class="getIconClass(item)" style="min-height: 80px">
              <div class="inner">
                <div class="text">{{ item.label }}</div>
                <div class="number">{{ item.cnt }}</div>
              </div>
            </div>
            <!-- 오른쪽 현황 -->
            <div class="table-container" style="margin-top: 20px">
              <!-- 테이블 -->
              <div class="status-table" style="display:flex;height:5px;margin-bottom:10px">
                <el-tooltip v-for="(info, index) in objTypeInfo" :key="info.id"  placement="top">
                  <div slot="content">{{info.label}} {{info.cnt}}대</div>
                  <span :style="[{width:`${(info.cnt / item.cnt) * 100}%`}, {background: getBoxColor(index)}, {'margin-right': getBoxMargin(index)}, {'border-radius': '2px'} ]" />
                </el-tooltip>
              </div>
              <!-- 범례 -->
              <w-summary-cofig-legend :objTypeInfo="objTypeInfo" style="width:98%"></w-summary-cofig-legend>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import perfApi from '@/api/performance/root';
import treeApi from '@/api/common/tree';
import isEmpty from 'lodash/isEmpty';
import WSummaryCofigLegend from './SummaryCofigLegend';

export default {
  name: 'WSummaryConfigurationStatus',
  components: {
    WSummaryCofigLegend,
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      objDefineList: [],
      objTypeInfo: [],
    };
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  watch: {
    active: {
      immediate: true,
      handler() {
        if (this.active) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      perfApi.getObjCountByManagetypeForPerf().then((response) => {
        if (response.data.success) {
          const tempList = response.data.data;
          this.objDefineList = tempList.objCount;
        }
      });
    },
    /**
     * 카드 이동 시 관리대상 타입에 따라 구성 데이터를 가져온다
     * @author leesy918
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    onChangeCarousel(item) {
      if (!isEmpty(this.objDefineList)) {
        const managetypeId = this.objDefineList[item].id;
        if (!isEmpty(managetypeId)) {
          if (managetypeId === 'NMS') {
            treeApi.getObjCountByCompany(managetypeId).then((response) => {
              this.objTypeInfo = response.data.data;
            });
          } else if (managetypeId === 'VMS') {
            treeApi.getObjCountByHypervisorType(managetypeId).then((response) => {
              this.objTypeInfo = response.data.data;
            });
          } else {
            treeApi.getObjCountByType(managetypeId).then((response) => {
              this.objTypeInfo = response.data.data;
            });
          }
        }
      }
    },
    getBoxColor(index) {
      if (index % 2 === 0) {
        return '#3ec6ff';
      }
      return '#3459e8';
    },
    getBoxMargin(index) {
      const objTypeInfo = this.objTypeInfo;
      if (isEmpty(objTypeInfo)) {
        return null;
      }
      if (index + 1 === objTypeInfo.length) {
        return null;
      }
      return '6px';
    },
    getIconClass(objDefine) {
      const objDefineInfo = (objDefine.objDefineId === 'WIRELESS_DEVICE') ? 'NETDEVICE' : objDefine.objDefineId;
      return objDefineInfo.toLocaleLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.status-table {
  width: 98%;
  table {
    width: 100%;
    background: #f4f5f7;
    height: 5px;
    border-spacing: 8px 0px;
    margin: 3px 0 10px 0;
    tr {
      z-index: 999;
      & > td {
        position: relative;
        border-radius: 6px;
        &:hover {
          -webkit-transition: all 0.3s ease;
          -moz-transition: all 0.3s ease;
          -ms-transition: all 0.3s ease;
          -o-transition: all 0.3s ease;
          transition: all 0.3s ease;
          position: relative;
          bottom: 2px;
          box-shadow: 0 3px 3px rgba(136, 136, 136, 0.3);
        }
        & > div {
          margin: 0 auto;
        }
      }
      .lblue {
        background: #3ec6ff;
      }
      .pblue {
        background: #3459e8;
      }
    }
    .tooltip {
      padding: 0px !important;
      border: 0px solid #666 !important;
      min-width: 10px;
      .tooltiptext {
        visibility: hidden;
        background: rgba(90, 158, 228, 0.12);
        color: #2e70de;
        text-align: center;
        padding: 3px 10px;
        min-width: 120px;
        font-size: 11px;
        white-space: nowrap;
        /* Position the tooltip */
        position: absolute;
        bottom: -1px;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
        span {
          color: red;
          font-size: 12px;
          padding: 0 2px;
        }
      }
      &:hover .tooltiptext {
        visibility: visible;
      }
    }
  }
}
@media only screen and (max-width: 1500px) {
  .status-table {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/SummaryConfigurationStatus.vue